import {
    useBlockProps,
} from '@wordpress/block-editor';

export default function save({attributes}) {
    const {
        linkURL = {},
        content,
        mediaURL,
        mediaCaption,
        headline,
        explanation,
    } = attributes;

    const effectiveHeadline = headline?.trim() || content?.trim() || '';
    const effectiveLinkTitle = (linkURL?.title != linkURL.url && linkURL?.title != "View more") ? linkURL?.title : "View more";

    const blockProps = useBlockProps.save({
        className: 'bem-imagetextblock-save__row h-100',
    });

    return (
        <div {...blockProps}>
            <a
                target={linkURL?.opensInNewTab ? '_blank' : '_self'}
                href={linkURL?.url || '#'}
                rel="noopener"
            >
                <div className="bem-imagetextblock-save__card card h-100">
                    {mediaURL && (
                        <img
                            className="bem-imagetextblock-save__img card-img-top img-fluid rounded"
                            src={mediaURL}
                        />
                    )}
                    <div className="bem-imagetextblock-save__footer card-footer">
                        <small className="bem-imagetextblock-save__footersmall text-muted">
                            {mediaCaption}
                        </small>
                    </div>
                    <div className="bem-imagetextblock-save__cardbody card-body">
                        <div className="bem-imagetextblock-save__content">
                            {effectiveHeadline}
                        </div>
                        <div className="bem-imagetextblock-save__explanation">
                            {explanation}
                        </div>
                        <a
                            class="bem-imagetextblock-save__viewmore"
                            target={linkURL?.opensInNewTab ? '_blank' : '_self'}
                            href={linkURL?.url || '#'}
                            rel="noopener">
                            {effectiveLinkTitle}
                        </a>
                    </div>
                </div>
            </a>
        </div>
    );
}
